module.exports = __webpack_public_path__ + "static/media/intro3.0e60f8d2.png";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/intro3.png
// module id = 227
// module chunks = 0